import { BookOpenCheckIcon, CalculatorIcon, CogIcon, LayersIcon, SearchCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Mechanical Engineering Formula Reference',
    description: 'Essential formulas for force, motion, stress, design, thermodynamics, and heat transfer.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Industrial Machinery & Components Handbook',
    description: 'Motors, pumps, gearboxes, bearings, seals, and mechanical component reference guide.',
    icon: CogIcon,
  },
  {
    number: '3',
    title: 'Mechanical Engineering Troubleshooting Guide',
    description: 'Common machinery problems, vibration, noise, wear, and failure analysis methods.',
    icon: SearchCheckIcon,
  },
  {
    number: '4',
    title: 'Engineering Materials Selection Guide',
    description: 'Material classification, properties, strength, corrosion, temperature, and selection principles.',
    icon: LayersIcon,
  },
  {
    number: '5',
    title: 'Mechanical Engineering Terminology Dictionary',
    description: 'Essential technical terms and definitions for mechanical engineering practice.',
    icon: BookOpenCheckIcon,
  },
];
